"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const MobileWidth = 760; exports.MobileWidth = MobileWidth

// Mirrors $blmh-mobile-breakpoint in styles/base/_grid.scss. Below it, a
// .right-side-pane stops being a 300px column beside the conversation and
// becomes a fixed, full-viewport overlay (styles/components/_rightside.scss),
// which is the only thing that makes the distinction behaviourally load-bearing.
// Deliberately not MobileWidth: that is 760, and the 20px band between them
// would otherwise be treated as desktop while CSS renders it as an overlay.
 const PaneOverlayMaxWidth = 780; exports.PaneOverlayMaxWidth = PaneOverlayMaxWidth

 const isRightSidePaneOverlay = () => window.innerWidth < exports.PaneOverlayMaxWidth; exports.isRightSidePaneOverlay = isRightSidePaneOverlay
